import type { EditorReadyOptions, EditorSDK } from '@wix/platform-editor-sdk';

import { log, toMonitored } from '../../../../utils/monitoring';
import { APP_TOKEN, IDENTITY_AUTH_APP_DEF_ID } from '../../../constants';
import { addInitialMenuItemsToMemberMenus } from '../integration/menu-items';
import { addGlobalController } from '../services/global-controller';
import { installMembersBlocksPlatform } from '../services/members-blocks-platform';
import { addLoginMenus, addMemberSettingsSubMenu, addProfileSubMenu } from '../services/menu';
import { navigateToMemberSettingsPage } from '../services/navigation';

export const monitoredAddGlobalController = async (editorSDK: EditorSDK) => {
  try {
    await toMonitored('v3.install.addGlobalController', () => addGlobalController(editorSDK));
  } catch (error: any) {
    if (error?.message?.includes?.('already exists')) {
      return;
    }

    throw error;
  }
};

export const monitoredInstallMembersBlocksPlatform = (editorSDK: EditorSDK, isSocialInstallation: boolean) => {
  const action = () => installMembersBlocksPlatform(editorSDK, isSocialInstallation);
  return toMonitored('v3.install.installMembersBlocksPlatform', action);
};

export const monitoredMaybeInstallIdentityAuthApp = async (editorSDK: EditorSDK) => {
  const isAppInstalledAction = async () => {
    return editorSDK.application.isApplicationInstalled(APP_TOKEN, {
      appDefinitionId: IDENTITY_AUTH_APP_DEF_ID,
    });
  };
  const isAppInstalled = await toMonitored('v3.install.isIdentityAuthAppInstalled', isAppInstalledAction);

  if (isAppInstalled) {
    return;
  }

  const installAction = async () => {
    try {
      return await editorSDK.application.install(APP_TOKEN, {
        appDefinitionId: IDENTITY_AUTH_APP_DEF_ID,
        isSilent: true,
      });
    } catch (e: any) {
      log('Failed to install identity auth app', { extra: { e: e.toString() } });
    }
  };

  return toMonitored('v3.install.installIdentityAuthApp', installAction);
};

export const monitoredAddMemberSettingsSubMenu = (editorSDK: EditorSDK) => {
  const action = () => addMemberSettingsSubMenu(editorSDK);
  return toMonitored('v3.install.addMemberSettingsSubMenu', action);
};

export const monitoredAddProfileSubMenu = (editorSDK: EditorSDK) => {
  const action = () => addProfileSubMenu(editorSDK);
  return toMonitored('v3.install.addProfileSubMenu', action);
};

export const monitoredAddLoginMenus = (editorSDK: EditorSDK, options: EditorReadyOptions) => {
  const action = () => addLoginMenus(editorSDK, options);
  return toMonitored('v3.install.addLoginMenus', action);
};

export const monitoredAddInitialMenuItemsToMemberMenus = (editorSDK: EditorSDK, options: EditorReadyOptions) => {
  const action = () => addInitialMenuItemsToMemberMenus(editorSDK, options);
  return toMonitored('v3.install.addInitialMenuItemsToMemberMenus', action);
};

export const monitoredNavigateToMemberSettingsPage = (editorSDK: EditorSDK) => {
  return toMonitored('v3.install.navigateAfterInstallation', () => navigateToMemberSettingsPage(editorSDK));
};
